import { GroupMember, GroupPermission } from '@ih/app/shared/apis/interfaces';

export class SetGroupPermissionsAction {
  public static readonly type = '[Authorisation] SetGroupPermissionsAction';
  constructor(
    public readonly groupMembers: GroupMember[],
    public readonly permissions: GroupPermission[],
  ) {}
}
